import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDataRawSet } from '@/models/alo/AloDataRawSet'
import { AloGliderFileListReport } from '@/models/alo/AloGliderFileListReport'
import { AloGliderFileShort } from '@/models/alo/AloGliderFileShort'
import { AloLogbookChannel } from '@/models/alo/AloLogbookChannel'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'
import { AloMission, arrayToDataNavigationArr, arrayToDataScienceArr } from '@/models/alo/AloMission'
import { AloMissionPlan } from '@/models/alo/AloMissionPlan'
import { AloUploadResult } from '@/models/alo/AloUploadResult'
import { AloYo } from '@/models/alo/AloYo'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { IrisrawModAd2cp } from '@/models/iris/IrisrawModAd2cp'
import { IrisrawModAis } from '@/models/iris/IrisrawModAis'
import { IrisrawModAisRoot } from '@/models/iris/IrisrawModAisRoot'
import { IrisrawModCoriolis } from '@/models/iris/IrisrawModCoriolis'
import { IrisrawModMissionPlan } from '@/models/iris/IrisrawModMissionPlan'
import { IrisrawModMissionPlanConfig } from '@/models/iris/IrisrawModMissionPlanConfig'
import { IrisrawModQuickControlConfig } from '@/models/iris/IrisrawModQuickControlConfig'
import { IrisrawModSendMail } from '@/models/iris/IrisrawModSendMail'
import { IAd2cpConfig } from '@/models/iris/ad2cp/IAd2cpConfig'
import { IAisConfig } from '@/models/iris/ais/IAisConfig'
import { ICoriolisConfig } from '@/models/iris/coriolis/ICoriolisConfig'
import { IMissionPlanConfig } from '@/models/iris/missionPlanConfig/IMissionPlanConfig'
import { IQuickControlConfig } from '@/models/iris/quickControlConfig/IQuickControlConfig'
import { ISendMailConfig } from '@/models/iris/sendMail/ISendMailConfig'
import { IEncryptionResponse } from '@/models/iris/encryption/IEncryptionResponse'
import { ISmartMission } from '@/models/iris/smartMission/ISmartMission'
import { ISmartSimulation } from '@/models/iris/smartMission/ISmartSimulation'
import { AlrContainer } from '@/models/response/AlrContainer'
import { ConsoleRow } from '@/models/ui/ConsoleRow'
import apiHelpers from '@/utils/api'
import axios, { AxiosProgressEvent, AxiosPromise } from 'axios'

export default {
  getMissions(
    ongoing: boolean | null = null,
    yos: boolean | null = null,
    gliIds: Array<number> | null,
  ): AxiosPromise<AlrContainer<AloBaseArray<AloMission>>> {
    return apiHelpers.apiCall({
      url: 'api/mission',
      method: 'GET',
      params: {
        ongoing: ongoing == null ? null : ongoing ? 1 : 0,
        yos: yos == null ? null : yos ? 1 : 0,
        gliIds: gliIds?.join(','),
      },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloBaseArray<AloMission>>(JSON.parse(data), AloMission.createAloMissionArray)
        },
      ],
    })
  },
  getVirtualMissions(
    ongoing: boolean | null = null,
    yos: boolean | null = null,
  ): AxiosPromise<AlrContainer<AloBaseArray<AloMission>>> {
    return apiHelpers.apiCall({
      url: 'api/missionvirtual',
      method: 'GET',
      params: { ongoing: ongoing == null ? null : ongoing ? 1 : 0, yos: yos == null ? null : yos ? 1 : 0 },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloBaseArray<AloMission>>(JSON.parse(data), AloMission.createAloMissionArray)
        },
      ],
    })
  },
  getIrisImageMission(id: number, yoOrAll: string, picNumber = 1): AxiosPromise<any> {
    return apiHelpers.apiCall({
      //url: `api/iris/image/${id}/${yoOrAll}/${picNumber}`,
      url: `api/custompicture/${id}/${yoOrAll}/${picNumber}`,
      method: 'GET',
      responseType: 'blob',
    })
  },
  getIrisImageList(id: number, yoOrAll: string): AxiosPromise<any> {
    return apiHelpers.apiCall({
      url: `api/custompicture/${id}/${yoOrAll}/list`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return (
            JSON.parse(data)?.data?.items?.map((it: any) => ({ yoCycle: it.yoCycle, picNumber: it.picNumber })) || []
          )
        },
      ],
    })
  },
  getMission(id: number): AxiosPromise<AlrContainer<AloMission>> {
    return apiHelpers.apiCall({
      url: `api/mission/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloMission>(JSON.parse(data), AloMission.createAloMissionWithDetail)
        },
      ],
    })
  },
  getGospAsConsoleRow({
    id,
    nb,
    stop = null,
    wob = 0,
  }: {
    id: number
    nb?: number
    stop?: number | null
    wob?: number
  }): AxiosPromise<AlrContainer<Array<ConsoleRow>>> {
    return apiHelpers.apiCall({
      url: `api/gosp/mission/${id}`,
      method: 'GET',
      params: { nb, stop, wob },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<Array<ConsoleRow>>(JSON.parse(data), ConsoleRow.createConsoleRowArray)
        },
      ],
    })
  },
  getDrift(id: number): AxiosPromise<AlrContainer<AloBaseArray<AloYo>>> {
    return apiHelpers.apiCall({
      url: `api/mission/${id}/drift`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloBaseArray<AloYo>>(JSON.parse(data), AloYo.createAloYoArray)
        },
      ],
    })
  },
  getDataScience(id: number, targetYosCycles: Array<number> | null): AxiosPromise<AlrContainer<Array<any>>> {
    return apiHelpers.apiCall({
      url: `api/mesure/${id}`,
      method: 'GET',
      params: { targetYosCycles: targetYosCycles && targetYosCycles.length <= 20 ? targetYosCycles.join(',') : null },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<Array<any>>(JSON.parse(data), arrayToDataScienceArr)
        },
      ],
    })
  },
  getDataNmea(typeNmea: string, id: Number): AxiosPromise<AlrContainer<AloDataRawSet>> {
    return apiHelpers.apiCall({
      url: `api/nmea/${typeNmea}/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloDataRawSet>(JSON.parse(data), AloDataRawSet.createAloDataRawSetWithDetail)
        },
      ],
    })
  },
  getNmeaInfos(): AxiosPromise<AlrContainer<{ [index: string]: Array<string> }>> {
    return apiHelpers.apiCall({
      url: `api/nmea/schema`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<Array<{ [index: string]: Array<string> }>>(JSON.parse(data), it => it)
        },
      ],
    })
  },
  getDataNavigation(id: number, targetYosCycles: Array<number> | null) {
    return apiHelpers.apiCall({
      url: `api/navdata/${id}`,
      method: 'GET',
      params: { targetYosCycles: targetYosCycles && targetYosCycles.length <= 20 ? targetYosCycles.join(',') : null },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<Array<any>>(JSON.parse(data), arrayToDataNavigationArr)
        },
      ],
    })
  },
  saveImageMission({
    imageData,
    name,
  }: {
    imageData: string
    name: string
  }): AxiosPromise<AlrContainer<AloUploadResult>> {
    return apiHelpers.apiCall({
      url: `api/tools/upload`,
      method: 'POST',
      data: { dataEnc64: imageData, name, typ: 'graphimage' },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloUploadResult>(JSON.parse(data), AloUploadResult.createAloUploadResult)
        },
      ],
    })
  },
  getImageMission(name: string): AxiosPromise<any> {
    return apiHelpers.apiCall({
      url: `api/tools/download`,
      method: 'GET',
      params: { name, typ: 'graphimage' },
      responseType: 'blob',
    })
  },
  savePublicImage({
    imageData,
    name,
  }: {
    imageData: string
    name: string
  }): AxiosPromise<AlrContainer<AloUploadResult>> {
    return apiHelpers.apiCall({
      url: `api/tools/upload`,
      method: 'POST',
      data: { dataEnc64: imageData, name, typ: 'publicimage' },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloUploadResult>(JSON.parse(data), AloUploadResult.createAloUploadResult)
        },
      ],
    })
  },
  getPublicImage(name: string): AxiosPromise<any> {
    return apiHelpers.apiCall({
      url: `api/tools/download`,
      method: 'GET',
      params: { name, typ: 'publicimage' },
      responseType: 'blob',
    })
  },
  getGliderFile(misId: number): AxiosPromise<AlrContainer<AloBaseArray<AloGliderFileShort>>> {
    return apiHelpers.apiCall({
      url: `api/gliderfile/`,
      params: {
        mis: misId,
      },
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloBaseArray<AloGliderFileShort>>(
            JSON.parse(data),
            AloGliderFileShort.createAloGliderFileShortArray,
          )
        },
      ],
    })
  },
  postFileList(list: Array<string>): AxiosPromise<AlrContainer<AloGliderFileListReport>> {
    return apiHelpers.apiCall({
      url: `api/gliderfile/upload/list`,
      data: {
        fileNames: list,
      },
      method: 'POST',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloGliderFileListReport>(
            JSON.parse(data),
            AloGliderFileListReport.createAloGliderFileListReport,
          )
        },
      ],
    })
  },
  uploadFile({
    file,
    progress,
  }: {
    file: File
    progress: (e: AxiosProgressEvent) => void | null
  }): AxiosPromise<AlrContainer<AloGliderFileListReport>> {
    const formData = new FormData()
    formData.append('formFile', file, file.name)
    return axios({
      url: `api/gliderfile/upload/file`,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progress,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloGliderFileListReport>(
            JSON.parse(data),
            AloGliderFileListReport.createAloGliderFileListReport,
          )
        },
      ],
    })
  },
  postCoriolisFileList(list: Array<string>): AxiosPromise<AlrContainer<AloGliderFileListReport>> {
    return apiHelpers.apiCall({
      url: `api/gliderfile/upload/coriolis/list`,
      data: {
        fileNames: list,
      },
      method: 'POST',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloGliderFileListReport>(
            JSON.parse(data),
            AloGliderFileListReport.createAloGliderFileListReport,
          )
        },
      ],
    })
  },

  uploadCoriolisFile({
    misId,
    file,
    progress,
  }: {
    misId: number
    file: File
    progress: (e: AxiosProgressEvent) => void | null
  }): AxiosPromise<AlrContainer<AloGliderFileListReport>> {
    const formData = new FormData()
    formData.append('formFile', file, file.name)
    return axios({
      url: `api/iris/coriolis/${misId}/file`,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progress,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloGliderFileListReport>(
            JSON.parse(data),
            AloGliderFileListReport.createAloGliderFileListReport,
          )
        },
      ],
    })
  },
  endMission(id: number): AxiosPromise<AlrContainer<AloMission>> {
    return apiHelpers.apiCall({
      url: `api/mission/close/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloMission>(JSON.parse(data), AloMission.createAloMissionWithDetail)
        },
      ],
    })
  },
  getLogbook(id: number): AxiosPromise<AlrContainer<AloLogbookChannel>> {
    return apiHelpers.apiCall({
      url: `api/logbook/mission/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloLogbookChannel>(JSON.parse(data), AloLogbookChannel.createAloLogbookChannel)
        },
      ],
    })
  },
  getLogbookItem(id: number): AxiosPromise<AlrContainer<AloLogbookItem>> {
    return apiHelpers.apiCall({
      url: `api/logbook/logitem/${id}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloLogbookItem>(JSON.parse(data), AloLogbookItem.createAloLogbookItem)
        },
      ],
    })
  },
  addMessageToLogbook({
    misId,
    message,
  }: {
    misId: number
    message: string
  }): AxiosPromise<AlrContainer<AloLogbookItem>> {
    return apiHelpers.apiCall({
      url: `api/logbook/mission/${misId}`,
      method: 'POST',
      data: { message },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloLogbookItem>(JSON.parse(data), AloLogbookItem.createAloLogbookItem)
        },
      ],
    })
  },
  updateMessageToLogbook({
    lbkId,
    message,
  }: {
    lbkId: number
    message: string
  }): AxiosPromise<AlrContainer<AloLogbookItem>> {
    return apiHelpers.apiCall({
      url: `api/logbook/message/${lbkId}`,
      method: 'PUT',
      data: { message },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloLogbookItem>(JSON.parse(data), AloLogbookItem.createAloLogbookItem)
        },
      ],
    })
  },
  getSendMailConfig(misId: number): AxiosPromise<AlrContainer<IrisrawModSendMail>> {
    return apiHelpers.apiCall({
      url: `api/iris/sendMail/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModSendMail>(JSON.parse(data), IrisrawModSendMail.createIrisrawModSendMail)
        },
      ],
    })
  },
  saveSendMailConfig(
    misId: number,
    nsdConfig: IrisConfigContainer<ISendMailConfig>,
  ): AxiosPromise<AlrContainer<IrisrawModSendMail>> {
    return apiHelpers.apiCall({
      url: `api/iris/sendMail/${misId}/`,
      method: 'PUT',
      data: nsdConfig,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModSendMail>(JSON.parse(data), IrisrawModSendMail.createIrisrawModSendMail)
        },
      ],
    })
  },
  enableSendMailModule(misId: number, enable: boolean): AxiosPromise<AlrContainer<IrisrawModSendMail>> {
    return apiHelpers.apiCall({
      url: `api/iris/sendMail/${misId}/`,
      method: 'PUT',
      data: { mod_settings: { EnabledMOD: { 'module-SendMail': enable } } },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModSendMail>(JSON.parse(data), IrisrawModSendMail.createIrisrawModSendMail)
        },
      ],
    })
  },
  addMissionLayerLink(misId: number, layId: number): AxiosPromise<any> {
    return apiHelpers.apiCall({
      url: `api/mission/${misId}/maplayer/${layId}`,
      method: 'POST',
    })
  },
  deleteMissionLayerLink(misId: number, layId: number): AxiosPromise<any> {
    return apiHelpers.apiCall({
      url: `api/mission/${misId}/maplayer/${layId}`,
      method: 'DELETE',
    })
  },
  getLastMissionPlan(misId: number) {
    return apiHelpers.apiCall({
      url: `api/missionplan/mission/${misId}/last`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloMissionPlan>(JSON.parse(data), AloMissionPlan.createAloMissionPlanWithDetail)
        },
      ],
    })
  },
  publishMissionPlan(misId: number) {
    return apiHelpers.apiCall({
      url: `api/missionplan/${misId}/publish`,
      method: 'POST',
    })
  },
  populateMissionPlanFromTemplate(mptId: number, misId: number) {
    return apiHelpers.apiCall({
      url: `api/missionplan/template/${mptId}/pop/mission/${misId}`,
      method: 'GET',
    })
  },
  saveLastMissionPlan(missionPlan: AloMissionPlan) {
    if (missionPlan.id && missionPlan.id > 0) {
      return apiHelpers.apiCall({
        url: `api/missionplan/${missionPlan.id}`,
        method: 'PUT',
        data: missionPlan,
        transformResponse: [
          function (data: string) {
            return new AlrContainer<AloMissionPlan>(JSON.parse(data), AloMissionPlan.createAloMissionPlanWithDetail)
          },
        ],
      })
    } else {
      //@ts-ignore
      delete missionPlan.id
      return apiHelpers.apiCall({
        url: `api/missionplan`,
        method: 'POST',
        data: missionPlan,
        transformResponse: [
          function (data: string) {
            return new AlrContainer<AloMissionPlan>(JSON.parse(data), AloMissionPlan.createAloMissionPlanWithDetail)
          },
        ],
      })
    }
  },
  getIrisMissionPlanInfos(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/missionplan/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModMissionPlan>(
            JSON.parse(data),
            IrisrawModMissionPlan.createIrisrawModMissionPlan,
          )
        },
      ],
    })
  },
  getIrisMissionPlanConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/missionplanconfig/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModMissionPlan>(
            JSON.parse(data),
            IrisrawModMissionPlan.createIrisrawModMissionPlan,
          )
        },
      ],
    })
  },
  saveIrisMissionPlanConfig(
    misId: number,
    missionPlanConfig: IrisConfigContainer<IMissionPlanConfig>,
  ): AxiosPromise<AlrContainer<IrisrawModMissionPlanConfig>> {
    return apiHelpers.apiCall({
      url: `api/iris/missionplanconfig/${misId}/`,
      method: 'PUT',
      data: missionPlanConfig,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModMissionPlanConfig>(
            JSON.parse(data),
            IrisrawModMissionPlanConfig.createIrisrawModMissionPlanConfig,
          )
        },
      ],
    })
  },
  enableIrisMissionPlanModule(misId: number, enable: boolean): AxiosPromise<AlrContainer<IrisrawModMissionPlanConfig>> {
    return apiHelpers.apiCall({
      url: `api/iris/missionplanconfig/${misId}/`,
      method: 'PUT',
      data: { mod_settings: { EnabledMOD: { 'module-MissionPlan': enable } } },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModMissionPlanConfig>(
            JSON.parse(data),
            IrisrawModMissionPlanConfig.createIrisrawModMissionPlanConfig,
          )
        },
      ],
    })
  },
  getAd2cpConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/ad2cp/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAd2cp>(JSON.parse(data), IrisrawModAd2cp.createIrisrawModAd2cp)
        },
      ],
    })
  },
  saveAd2cpConfig(
    misId: number,
    ad2cpConfig: IrisConfigContainer<IAd2cpConfig>,
  ): AxiosPromise<AlrContainer<IrisrawModAd2cp>> {
    return apiHelpers.apiCall({
      url: `api/iris/ad2cp/${misId}/`,
      method: 'PUT',
      data: ad2cpConfig,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAd2cp>(JSON.parse(data), IrisrawModAd2cp.createIrisrawModAd2cp)
        },
      ],
    })
  },
  enableAd2cpModule(misId: number, enable: boolean): AxiosPromise<AlrContainer<IrisrawModAd2cp>> {
    return apiHelpers.apiCall({
      url: `api/iris/ad2cp/${misId}/`,
      method: 'PUT',
      data: { mod_settings: { EnabledMOD: { 'module-AD2CP': enable } } },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAd2cp>(JSON.parse(data), IrisrawModAd2cp.createIrisrawModAd2cp)
        },
      ],
    })
  },
  runAd2cpConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/ad2cp/${misId}/refresh`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<any>(JSON.parse(data), t => t)
        },
      ],
    })
  },
  getCoriolisConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/coriolis/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModCoriolis>(JSON.parse(data), IrisrawModCoriolis.createIrisrawModCoriolis)
        },
      ],
    })
  },
  saveCoriolisConfig(
    misId: number,
    coriolisConfig: IrisConfigContainer<ICoriolisConfig>,
  ): AxiosPromise<AlrContainer<IrisrawModCoriolis>> {
    return apiHelpers.apiCall({
      url: `api/iris/coriolis/${misId}/`,
      method: 'PUT',
      data: coriolisConfig,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModCoriolis>(JSON.parse(data), IrisrawModCoriolis.createIrisrawModCoriolis)
        },
      ],
    })
  },
  enableCoriolisModule(misId: number, enable: boolean): AxiosPromise<AlrContainer<IrisrawModCoriolis>> {
    return apiHelpers.apiCall({
      url: `api/iris/ad2cp/${misId}/`,
      method: 'PUT',
      data: { mod_settings: { EnabledMOD: { 'module-AD2CP': enable } } },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModCoriolis>(JSON.parse(data), IrisrawModCoriolis.createIrisrawModCoriolis)
        },
      ],
    })
  },
  runCoriolisConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/coriolis/${misId}/refresh`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<any>(JSON.parse(data), t => t)
        },
      ],
    })
  },
  getAisConfig(misId: number) {
    return apiHelpers.apiCall({
      url: `api/iris/ais/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAis>(JSON.parse(data), IrisrawModAis.createIrisrawModAis)
        },
      ],
    })
  },
  getAisRootConfig(): AxiosPromise<AlrContainer<IrisrawModAisRoot>> {
    return apiHelpers.apiCall({
      url: `api/iris/aisrootconfig/0`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAisRoot>(JSON.parse(data), IrisrawModAisRoot.createIrisrawModAisRoot)
        },
      ],
    })
  },
  saveAisConfig(misId: number, aisConfig: IrisConfigContainer<IAisConfig>): AxiosPromise<AlrContainer<IrisrawModAis>> {
    return apiHelpers.apiCall({
      url: `api/iris/ais/${misId}/`,
      method: 'PUT',
      data: aisConfig,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAis>(JSON.parse(data), IrisrawModAis.createIrisrawModAis)
        },
      ],
    })
  },
  enableAisModule(misId: number, enable: boolean): AxiosPromise<AlrContainer<IrisrawModAis>> {
    return apiHelpers.apiCall({
      url: `api/iris/ais/${misId}/`,
      method: 'PUT',
      data: { mod_settings: { EnabledMOD: { 'module-AIS': enable } } },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModAis>(JSON.parse(data), IrisrawModAis.createIrisrawModAis)
        },
      ],
    })
  },
  runEndMissionSimulation(misId: number, data: ISmartSimulation) {
    //On verifie que les parametre son ok
    //affecte la valeur par default au step courant
    //@ts-ignore
    //supprime l'info de missionPlanTemplate
    delete data.templateSimId

    return apiHelpers.apiCall({
      url: `api/iris/processingSimulatorMisEnding/${misId}`,
      method: 'POST',
      data,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<ISmartMission>(JSON.parse(data), d => d)
        },
      ],
    })
  },
  getEncryptionConfig(misId: number): AxiosPromise<AlrContainer<IEncryptionResponse>> {
    return apiHelpers.apiCall({
      url: `api/iris/passphrase/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IEncryptionResponse>(JSON.parse(data), d => d)
        },
      ],
    })
  },
  saveEncryptionConfig(misId: number, passphrase: string): AxiosPromise<AlrContainer<any>> {
    return apiHelpers.apiCall({
      url: `api/iris/passphrase/${misId}/`,
      method: 'POST',
      data: { data: passphrase },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<any>(JSON.parse(data), d => d)
        },
      ],
    })
  },
  saveLkb(misId: number, alertStatus: number): AxiosPromise<AlrContainer<AloMission>> {
    return apiHelpers.apiCall({
      url: `api/mission/${misId}/lbk`,
      method: 'PUT',
      data: { alertStatus },
      transformResponse: [
        function (data: string) {
          return new AlrContainer<AloMission>(JSON.parse(data), AloMission.createAloMissionWithDetail)
        },
      ],
    })
  },

  getQuickControlConfig(misId: number): AxiosPromise<AlrContainer<IrisrawModQuickControlConfig>> {
    return apiHelpers.apiCall({
      url: `api/iris/quickcontrolconfig/${misId}`,
      method: 'GET',
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModQuickControlConfig>(
            JSON.parse(data),
            IrisrawModQuickControlConfig.createIrisrawModQuickControlConfig,
          )
        },
      ],
    })
  },

  putQuickControlConfig(
    misId: number,
    config: IrisConfigContainer<IQuickControlConfig>,
  ): AxiosPromise<AlrContainer<IrisrawModQuickControlConfig>> {
    return apiHelpers.apiCall({
      url: `api/iris/quickcontrolconfig/${misId}`,
      method: 'PUT',
      data: config,
      transformResponse: [
        function (data: string) {
          return new AlrContainer<IrisrawModQuickControlConfig>(
            JSON.parse(data),
            IrisrawModQuickControlConfig.createIrisrawModQuickControlConfig,
          )
        },
      ],
    })
  },
}
